// extracted by mini-css-extract-plugin
export default {"box":"SignIn_box__VgIXy"};